export const SERVICE_KEY = 'deployer';
export const DEPLOYER_SERVICE_KEY = SERVICE_KEY;
//# sourceMappingURL=constants.js.map